export class CountdownSynth {
  private ctx: AudioContext;
  private output: GainNode;

  constructor(ctx: AudioContext, output: GainNode) {
    this.ctx = ctx;
    this.output = output;
  }

  playBeep(count: number): void {
    const now = this.ctx.currentTime;

    // Create oscillator
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    // Frequency: 440Hz for 3,2 and 523Hz (C5) for 1
    const frequency = count === 1 ? 523.25 : 440;
    osc.type = 'sine';
    osc.frequency.setValueAtTime(frequency, now);

    // Connect
    osc.connect(gain);
    gain.connect(this.output);

    // Envelope - short beep with quick decay
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.3, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.15);

    // Play
    osc.start(now);
    osc.stop(now + 0.2);
  }

  playGo(): void {
    const now = this.ctx.currentTime;

    // Rising sweep for "GO!"
    const osc1 = this.ctx.createOscillator();
    const osc2 = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    osc1.type = 'sine';
    osc2.type = 'triangle';

    // Sweep from 440 to 880 Hz
    osc1.frequency.setValueAtTime(440, now);
    osc1.frequency.exponentialRampToValueAtTime(880, now + 0.2);
    osc2.frequency.setValueAtTime(440, now);
    osc2.frequency.exponentialRampToValueAtTime(880, now + 0.2);

    // Connect
    osc1.connect(gain);
    osc2.connect(gain);
    gain.connect(this.output);

    // Envelope
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.4, now + 0.02);
    gain.gain.setValueAtTime(0.4, now + 0.15);
    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);

    // Play
    osc1.start(now);
    osc2.start(now);
    osc1.stop(now + 0.5);
    osc2.stop(now + 0.5);
  }
}
